import { render, staticRenderFns } from "./ChinaPackingDetail.vue?vue&type=template&id=2adc5d6e"
import script from "./ChinaPackingDetail.vue?vue&type=script&lang=js"
export * from "./ChinaPackingDetail.vue?vue&type=script&lang=js"
import style0 from "./ChinaPackingDetail.vue?vue&type=style&index=0&id=2adc5d6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports